import { render, staticRenderFns } from "./ForumTemuan.vue?vue&type=template&id=5670bce2&scoped=true&"
import script from "./ForumTemuan.vue?vue&type=script&lang=js&"
export * from "./ForumTemuan.vue?vue&type=script&lang=js&"
import style0 from "./ForumTemuan.vue?vue&type=style&index=0&id=5670bce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670bce2",
  null
  
)

export default component.exports